import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { footerData } from "../data/mock";
import { MapPin } from "lucide-react";
import { scrollToId } from "../lib/motion";

export const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLink = (item) => {
    if (item.external) {
      window.open(item.href, "_blank", "noopener,noreferrer");
      return;
    }
    if (item.href.startsWith("/#")) {
      const hash = item.href.split("#")[1];
      if (location.pathname !== "/") {
        navigate("/");
        setTimeout(() => scrollToId(hash), 250);
      } else {
        scrollToId(hash);
      }
    } else {
      navigate(item.href);
    }
  };

  return (
    <footer data-testid="site-footer" className="bg-[#032e2d] text-teal-100/70 relative grain overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-5">
              <img
                src="https://customer-assets.emergentagent.com/job_teqie-new/artifacts/on53b2n6_Teqie%20Logo.webp"
                alt="Teqie"
                className="h-9 w-auto brightness-0 invert opacity-90"
              />
            </div>
            <p className="text-teal-100/80 max-w-sm leading-relaxed font-display text-lg">
              {footerData.tagline}
            </p>
            <div className="flex items-center gap-3 mt-7">
              {footerData.social.map((s, i) => {
                const Icon = s.icon;
                return (
                  <a
                    key={i}
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={s.label}
                    data-testid={`footer-social-${s.label.toLowerCase()}`}
                    className="w-10 h-10 rounded-full border border-teal-100/20 hover:border-teal-100/50 hover:bg-teal-100/10 flex items-center justify-center transition-all duration-300"
                  >
                    <Icon className="w-4 h-4 text-teal-100/80" />
                  </a>
                );
              })}
            </div>
          </div>

          {footerData.links.map((col, i) => (
            <div key={i}>
              <h4 className="text-[11px] font-semibold text-teal-200/60 uppercase tracking-[0.22em] mb-5">
                {col.title}
              </h4>
              <ul className="space-y-3">
                {col.items.map((item, j) => (
                  <li key={j}>
                    <button
                      onClick={() => handleLink(item)}
                      data-testid={`footer-link-${item.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                      className="text-sm text-teal-100/70 hover:text-white transition-colors duration-200 link-underline"
                    >
                      {item.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="py-6 border-t border-teal-100/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-teal-100/50">{footerData.copyright}</p>
          <div className="flex items-center gap-1.5 text-sm text-teal-100/50">
            <MapPin className="w-3.5 h-3.5" />
            <span>{footerData.location}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
